import styled from 'styled-components'


export const _Submit = styled.input`
  display: none;
`
